import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "more-details-page"
};
const _hoisted_2 = { class: "policy-card-container" };
const _hoisted_3 = { class: "content-section" };
const _hoisted_4 = { class: "anchor-bottom-no-nav" };
import { ref, computed, onMounted, useTemplateRef } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useInsurance } from '@/composables/useInsurance';
import { useContent } from '@/composables/useContent';
import { getHttpInstance, getApiConfig } from '@/composables/useApi';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import InputSections from './elements/InputSections.vue';
import MGButton from './elements/MGButton.vue';
import AccountListItem from './elements/AccountListItem.vue';
import WhatsAppPromoCard from './elements/WhatsAppPromoCard.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AddInsuranceMoreDetailsPage',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getPolicy, getInsuranceInfo, getInsuranceProviders, updatePolicy: updatePolicyApi } = useInsurance();
        const { getAiopSection } = useContent();
        const whatsAppPromoCard = useTemplateRef('whatsAppPromoCard');
        const sections = ref([]);
        const policySections = ref([]);
        const coverSections = ref([]);
        const helpSections = ref([]);
        const showWhatsappCard = ref(true);
        const policy = ref(null);
        const policyId = computed(() => {
            return route.query.policyId;
        });
        function formatDate(dateString) {
            if (!dateString)
                return '';
            const date = new Date(dateString);
            const options = { day: 'numeric', month: 'long', year: 'numeric' };
            return date.toLocaleDateString('en-GB', options);
        }
        function findFieldByIdInSections(sectionsList, fieldId) {
            for (const section of sectionsList) {
                for (const field of section.fields) {
                    if (field.id === fieldId) {
                        return field;
                    }
                }
            }
            return null;
        }
        function findFieldValueByIdInSections(sectionsList, fieldId) {
            for (const section of sectionsList) {
                for (const field of section.fields) {
                    if (field.id === fieldId && field.value != null) {
                        return field.value;
                    }
                }
            }
            return null;
        }
        function filterSectionsByRule(sectionsList, ruleKey, ruleValue) {
            return sectionsList.filter((section) => {
                if (!section.rule) {
                    return true;
                }
                const [key, values] = section.rule.split(':').map((s) => s.trim());
                if (key !== ruleKey) {
                    return true;
                }
                const allowedValues = values.split(',').map((s) => s.trim());
                return allowedValues.includes(ruleValue);
            });
        }
        function findFieldById(fieldId) {
            for (const section of sections.value) {
                for (const field of section.fields) {
                    if (field.id === fieldId) {
                        return field;
                    }
                }
            }
            return null;
        }
        function populateFields(sectionsList) {
            if (!policy.value)
                return sectionsList;
            const providerField = findFieldByIdInSections(sectionsList, 'provider');
            if (providerField) {
                providerField.value = policy.value.provider?.name || '';
            }
            const renewalDateField = findFieldByIdInSections(sectionsList, 'renewalDate');
            if (renewalDateField) {
                renewalDateField.value = formatDate(policy.value.endDate);
            }
            const payFrequencyField = findFieldByIdInSections(sectionsList, 'payFrequency');
            if (payFrequencyField && policy.value.payFrequency) {
                payFrequencyField.value = policy.value.payFrequency;
            }
            else if (payFrequencyField) {
                if (policy.value.annualPremium) {
                    payFrequencyField.value = 'Annually';
                }
                else if (policy.value.monthlyPremium) {
                    payFrequencyField.value = 'Monthly';
                }
            }
            const policyNumberField = findFieldByIdInSections(sectionsList, 'policyNumber');
            if (policyNumberField && policy.value.policyNumber) {
                policyNumberField.value = policy.value.policyNumber;
            }
            const premiumField = findFieldByIdInSections(sectionsList, 'premium');
            if (premiumField) {
                premiumField.value = policy.value.annualPremium || policy.value.monthlyPremium || null;
            }
            return sectionsList;
        }
        function findFieldValueInAllSections(fieldId) {
            const allSections = [
                ...sections.value,
                ...policySections.value,
                ...coverSections.value,
                ...helpSections.value
            ];
            return findFieldValueByIdInSections(allSections, fieldId);
        }
        function saveChanges() {
            const payFrequency = findFieldValueInAllSections('payFrequency');
            const policyNumber = findFieldValueInAllSections('policyNumber');
            const premium = findFieldValueInAllSections('premium');
            const excess = findFieldValueInAllSections('excess');
            const voluntaryExcess = findFieldValueInAllSections('voluntaryExcess');
            const totalExcess = (parseFloat(excess) || 0) + (parseFloat(voluntaryExcess) || 0);
            const sumInsured = findFieldValueInAllSections('sumInsured');
            const addressObject = findFieldValueInAllSections('address');
            let insuredItems = policy.value.insuredItems;
            if (addressObject && insuredItems && insuredItems.length > 0) {
                insuredItems[0].addressInsured = {
                    line1: addressObject?.line1 || null,
                    line2: addressObject?.line2 || null,
                    line3: addressObject?.line3 || null,
                    town: addressObject?.town || null,
                    postCode: addressObject?.postCode || null,
                };
            }
            const updatedPolicy = {
                id: policyId.value,
                policyType: policy.value.policyType,
                provider: policy.value.provider,
                insuredItems: insuredItems,
                startDate: policy.value.startDate,
                endDate: policy.value.endDate,
                payFrequency: payFrequency || null,
                policyNumber: policyNumber || null,
                annualPremium: payFrequency === 'Annually' ? premium : null,
                monthlyPremium: payFrequency === 'Monthly' ? premium : null,
                excess: totalExcess || policy.value.excess,
                voluntaryExcess: voluntaryExcess || policy.value.voluntaryExcess,
                noClaimsYears: policy.value.noClaimsYears,
                soleOrJoint: policy.value.soleOrJoint,
                sumAssured: sumInsured || policy.value.sumAssured,
                coverType: policy.value.coverType,
                travelCoverType: policy.value.travelCoverType,
                travelCoverage: policy.value.travelCoverage
            };
            updatePolicyApi(updatedPolicy, () => {
                getPolicy(policyId.value, null, true);
                getInsuranceInfo(null, true);
                router.push('/money');
            });
        }
        function handleWhatsAppAction() {
            if (state.customer) {
                if (state.customer.person.whatsAppEnabled) {
                    const request = {
                        "body": "You indicated you wanted to send a document 📄  Just drop it here and we will upload and process it for you 👍",
                        "whatsApp": true,
                        "whatsAppTemplate": false,
                        "phoneNumber": state.customer.person.mobilePhone
                    };
                    getHttpInstance().post(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/Notifications", request);
                    if (whatsAppPromoCard.value)
                        whatsAppPromoCard.value.setClicked();
                }
                else {
                    router.push('/#/enablewhatsapp');
                }
            }
        }
        function onLoad() {
            getAiopSection('InsuranceAdditionalSection.json', () => {
                sections.value = state.sectionJson;
                getCustomer();
                getInsuranceProviders((res) => {
                    res = res.filter((item) => item.buildings === true || item.contents === true || item.gadget === true
                        || item.car === true || item.motorbike === true || item.pet === true
                        || item.life === true || item.other === true)
                        .filter((item, index, self) => index === self.findIndex((t) => t.name === item.name));
                    const providerField = findFieldById('provider');
                    if (providerField) {
                        providerField.items = res.map((provider) => ({
                            name: provider.name.replace(/\w\S*/g, (txt) => {
                                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                            }),
                            logoUri: provider.logoUri
                        }));
                    }
                });
                getAiopSection('InsuranceAdditionalAbout.json', () => {
                    const aboutSections = state.sectionJson;
                    getAiopSection('InsuranceAdditionalCover.json', () => {
                        const coverSectionsJson = state.sectionJson;
                        getAiopSection('InsuranceAdditionalGettingHelp.json', () => {
                            const helpSectionsJson = state.sectionJson;
                            if (policyId.value) {
                                getPolicy(policyId.value, (result) => {
                                    policy.value = result;
                                    const policyType = policy.value.policyType?.name;
                                    sections.value = populateFields(sections.value);
                                    policySections.value = filterSectionsByRule(aboutSections, 'policyType', policyType);
                                    policySections.value = populateFields(policySections.value);
                                    coverSections.value = filterSectionsByRule(coverSectionsJson, 'policyType', policyType);
                                    coverSections.value = populateFields(coverSections.value);
                                    helpSections.value = filterSectionsByRule(helpSectionsJson, 'policyType', policyType);
                                    helpSections.value = populateFields(helpSections.value);
                                });
                            }
                            else {
                                router.push('/money');
                            }
                        });
                    });
                });
            });
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "Add more details",
                    bgcolor: "white",
                    border: "0"
                }),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).customer && policy.value
                }, null, 8, ["customer"]),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).customer && policy.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    _createVNode(AccountListItem, {
                                        "provider-name": policy.value.provider?.name || 'Provider',
                                        line1: policy.value.policyType?.name || 'Insurance',
                                        line2: policy.value.policyNumber || '',
                                        value: formatDate(policy.value.endDate),
                                        label: "Renewal",
                                        "avatar-url": policy.value.provider?.logoUri || require('@/assets/round1.png')
                                    }, null, 8, ["provider-name", "line1", "line2", "value", "avatar-url"])
                                ]),
                                _createElementVNode("div", _hoisted_3, [
                                    _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "page-title" }, "Add more details (optional)", -1)),
                                    _cache[2] || (_cache[2] = _createElementVNode("p", { class: "page-subtitle" }, "If you have them to hand, these details help keep everything in one place.", -1)),
                                    (showWhatsappCard.value)
                                        ? (_openBlock(), _createBlock(WhatsAppPromoCard, {
                                            key: 0,
                                            ref_key: "whatsAppPromoCard",
                                            ref: whatsAppPromoCard,
                                            subtitle: "We'll add the key details and save the document securely. You can also chat with our WhatsApp assistant about this policy.",
                                            onClose: _cache[0] || (_cache[0] = ($event) => (showWhatsappCard.value = false)),
                                            onAction: handleWhatsAppAction,
                                            class: "whatsapp-promo"
                                        }, null, 512))
                                        : _createCommentVNode("", true),
                                    _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "page-title" }, "Policy details", -1)),
                                    (sections.value.length)
                                        ? (_openBlock(), _createBlock(InputSections, {
                                            key: 1,
                                            ref: "inputSections",
                                            sections: sections.value,
                                            formatter: _unref(state).formatter,
                                            theme: "light",
                                            editMode: true,
                                            outline: false
                                        }, null, 8, ["sections", "formatter"]))
                                        : _createCommentVNode("", true)
                                ]),
                                _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "page-title" }, "About the cover", -1)),
                                (policySections.value.length)
                                    ? (_openBlock(), _createBlock(InputSections, {
                                        key: 0,
                                        ref: "policySectionsInput",
                                        sections: policySections.value,
                                        formatter: _unref(state).formatter,
                                        theme: "light",
                                        editMode: true,
                                        outline: false
                                    }, null, 8, ["sections", "formatter"]))
                                    : _createCommentVNode("", true),
                                _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "page-title" }, "Cover & limits", -1)),
                                _cache[6] || (_cache[6] = _createElementVNode("p", { class: "page-subtitle" }, "What's covered and where the limits apply.", -1)),
                                (coverSections.value.length)
                                    ? (_openBlock(), _createBlock(InputSections, {
                                        key: 1,
                                        ref: "coverSectionsInput",
                                        sections: coverSections.value,
                                        formatter: _unref(state).formatter,
                                        theme: "light",
                                        editMode: true,
                                        outline: false
                                    }, null, 8, ["sections", "formatter"]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_4, [
                                    _createVNode(MGButton, {
                                        text: "Save changes",
                                        fullWidth: true,
                                        onClick: saveChanges
                                    })
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
